import {createStore, applyMiddleware} from 'redux';
import rootReducer from '../reducers';
import {browserHistory} from 'react-router';
import {routerMiddleware} from 'react-router-redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';

const routingMiddleware = routerMiddleware(browserHistory);

export default function configureStore(initialState){
    return createStore(
        rootReducer,
        initialState,
        applyMiddleware(routingMiddleware, thunk, reduxImmutableStateInvariant())
    );
}


/** WEBPACK FOOTER **
 ** ./src/store/configureStore.dev.js
 **/